module.exports = __webpack_public_path__ + "img/sec5mob.e78d8aa4.png";